const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const Profile = () => import(/* webpackChunkName: "profile" */ '@/modules/profile/view/edit.vue');

export const ROUTE_NAME_PROFILE = 'Profile' as const;

export default [
    {
        path: '/profile',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_PROFILE,
                component: Profile,
                meta: { requiresAuth: true }
            }
        ]
    }
];
